import HashtagActionField from './hashtag-action-field';
import HashtagTitleField from './hashtag-title-field';


const HashtagFields = {
    Action: HashtagActionField,
    Title: HashtagTitleField,
}

export default HashtagFields;